<template>
  <header class="header">
    <div class="header__menu">
      <div class="header__menu--left">
        <img src="/static/img/common/header/back.svg" @click="back"/>
        <span class="header__menu__pageName">{{ displayPageName }}</span>
      </div>
      <div class="header__menu--right">
        <!-- TODO あとでみる 4/23以降に実装 -->
        <!-- <div v-if="isPlaylist" class="header__menu__seeLater" @click="seeLater">
          <img src="/static/img/common/header/see_later.svg"/>
          <span>{{ seeLaterNum }}</span>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'backHeader',
  data() {
    return {
    }
  },
  props: {
    pageName:{
      type: String,
      default:''
    },
    isPlaylist:{
      type: Boolean,
      default: true
    },
    seeLaterNum:{
      type: Number,
      default: 0
    },
  },
  computed: {
    displayPageName() {
      if (this.pageName === 'クレジットカード情報を登録する' && this.card.number) {
        return 'クレジットカード情報を変更する'
      } else {
        return this.pageName
      }
    },
    ...mapState({
      globalLock: state => state.uiState.globalLock,
      card: state => state.payment.card,    
    }),
  },
  methods: {
   back(){
     // -> GLOBAL_LOCKいれる（確認が必要なので一旦見送り）
     if(/^.+(uranai.tv|192.168.10.10)/.test(document.referrer)){
       history.back()
     } else {
       location.href = '/'
     }
   },
   seeLater(){
     //TODO 4/23以降に機能実装する
     // console.log('あとでみる')
   }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.header{
  position: fixed;
  height: 44px;
  width: 100%;
  z-index: 90001;
  background: $col_def_gradient;
  top: 0;
  left: 0;

  &__menu{
    height: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;

    &__pageName{
      font-size: 16px;
      color: $col_white;
      margin-left: 10px;
    }

    &__seeLater{
      display: flex;
      align-items: center;

      span{
        font-size: 11px;
        color: $col_white;
        margin-left: 5px;
      }
    }
    &--left{
      display: flex;
      align-items: center;
    }
    &--right{
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/BackHeader.vue